import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import { buildB2bCopilotPlanArtifactPayload, buildB2bCopilotPlanZipArtifactPayload } from '../demo/b2bCopilotPlanDemoContent.js'
import { B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID, B2B_COPILOT_PLAN_ZIP_ARTIFACT_ID } from '../demo/b2bCopilotPlanDemo.js'
import {
  NEXUS_DEMO_JOURNEY_THOUGHT_DETAILS,
  buildNexusDemoJourneySummaryFinalBlocks,
} from '../demo/nexusDemoJourneySummaryContent.js'
import {
  buildWebsiteCrmDocArtifactPayload,
  buildWebsiteCrmHtmlArtifactPayload,
} from '../demo/websiteCrmDemoContent.js'
import {
  WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID,
  WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
} from '../demo/websiteCrmDemo.js'
import { ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID } from '../demo/zohoCrmIntegrationDemo.js'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from '../demo/nexusIntegrationsDemo.js'
import { buildZohoCrmIntegrationArtifactPayload } from '../demo/zohoCrmIntegrationDemoContent.js'
import { formatWorkedForLabel } from '@/components/ChatResponseElements/AIResponseLog/formatWorkedForLabel.js'
import { computeStreamTypingDuration } from '../streaming/computeStreamTypingDuration.js'
import {
  randomPreamblePauseMs,
  scaleChatStreamContentDelay,
  scaleChatStreamDelay,
} from '../streaming/chatStreamSpeed.js'
import { runTypewriter } from '../streaming/runTypewriter.js'
import { runWorkflowStepsInStream } from './runWorkflowStepsInStream.js'
import { updatePendingNexusDemoJourneySummaryMessage } from './patchNexusDemoJourneySummaryMessage.js'



export function ensureNexusJourneyArtifactsRegistered() {
  registerArtifactPayload({
    artifactId: B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'B2B Copilot — Development Plan.md',
    description: 'Markdown',
    payload: buildB2bCopilotPlanArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: B2B_COPILOT_PLAN_ZIP_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'B2B Copilot.zip',
    description: 'Zip archive',
    payload: buildB2bCopilotPlanZipArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
    kind: 'html',
    fileName: 'NexusB2B — Procurement Site.html',
    description: 'HTML App',
    payload: buildWebsiteCrmHtmlArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
    description: 'Markdown',
    payload: buildZohoCrmIntegrationArtifactPayload(),
  })
  registerArtifactPayload({
    artifactId: WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'NexusB2B — CRM Test Report.md',
    description: 'Markdown',
    payload: buildWebsiteCrmDocArtifactPayload(),
  })
}

/** @param {import('./runNexusDemoJourneySummaryStream.js').NexusJourneySummaryStreamCtx} ctx */
